// color click code

  function updateEventListeners() {
    const isMobile = window.matchMedia("(max-width: 1023px)").matches;

    document.querySelectorAll(".product-card-wrapper").forEach(function (card) {
      let defaultImage = card.querySelector(".card__media img").getAttribute("src"); // Store original image

      card.querySelectorAll(".var-swatches").forEach(function (swatch) {
        // Remove previous event listeners
        swatch.removeEventListener("click", handleClick);
        swatch.removeEventListener("mouseover", handleHover);
        swatch.removeEventListener("mouseout", handleMouseOut);

        if (isMobile) {
          swatch.addEventListener("click", handleClick); // Enable click on mobile
        } else {
          swatch.addEventListener("mouseover", function (event) {
            handleHover(event, defaultImage);
          });
          swatch.addEventListener("mouseout", function (event) {
            handleMouseOut(event, defaultImage);
          });
        }
      });
    });
  }

  function handleHover(event, defaultImage) {
    let swatch = event.currentTarget;
    let card = swatch.closest(".product-card-wrapper");
    let variantImage = swatch.getAttribute("data-variant-image");
    let productImage = card.querySelector(".card__media img");

    if (variantImage && productImage) {
      productImage.src = variantImage;
      productImage.srcset = variantImage;
    }
  }

  function handleMouseOut(event, defaultImage) {
    let card = event.currentTarget.closest(".product-card-wrapper");
    let productImage = card.querySelector(".card__media img");
    let activeSwatch = card.querySelector(".var-swatches.active"); // Get active swatch

    if (activeSwatch) {
      let activeImage = activeSwatch.getAttribute("data-variant-image");
      if (activeImage) {
        productImage.src = activeImage;
        productImage.srcset = activeImage;
        return;
      }
    }

    if (defaultImage && productImage) {
      productImage.src = defaultImage;
      productImage.srcset = defaultImage;
    }
  }

  function handleClick(event) {
    if (!window.matchMedia("(max-width: 1023px)").matches) {
      return; // Prevent click events on large screens
    }

    let swatch = event.currentTarget;
    let card = swatch.closest(".product-card-wrapper");
    let variantImage = swatch.getAttribute("data-variant-image");
    let productImage = card.querySelector(".card__media img");
    let productLinks = card.querySelectorAll(".card__content a, .card__inner a");
    let variantID = swatch.getAttribute("variant-id");

    if (variantImage && productImage) {
      productImage.src = variantImage;
      productImage.srcset = variantImage;
    }

    // Remove 'active' class from all swatches in this card (only for mobile)
    card.querySelectorAll(".var-swatches").forEach((s) => s.classList.remove("active"));

    // Add 'active' class to the clicked swatch (only for mobile)
    swatch.classList.add("active");

    // Update product links with variant ID
    if (variantID) {
      productLinks.forEach((productLink) => {
        let productHref = productLink.getAttribute("href") || "#";
        productHref = productHref.split("?")[0]; // Remove existing query parameters
        productLink.href = `${productHref}?variant=${variantID}`;
      });
    }
  }

  // Run event listener setup initially and on window resize
  updateEventListeners();
  window.addEventListener("resize", updateEventListeners);




// hover on megamenu
let items = document
        .querySelector(".header__inline-menu")
        .querySelectorAll("details");
    items.forEach((item) => {
        item.addEventListener("mouseover", () => {
            item.setAttribute("open", true);
            item.querySelector("summary").setAttribute("aria-expanded", "true");
            item.addEventListener("mouseout", () => {
                item.removeAttribute("open");
                item.querySelector("summary").setAttribute("aria-expanded", "false");
            });
        });
    });

document.querySelectorAll('.price-item--sale').forEach(item => {
  item.innerHTML = item.innerHTML.replace(/From\s*/i, '');
});

//add zindex in mobile menu
document.querySelector('.mobile-facets__open')?.addEventListener('click', function () {
  document.querySelector('.facets-wrapper')?.classList.add('zz-index');
  // console.log("zz-index class added");
});

document.querySelector('.mobile-facets__close')?.addEventListener('click', function () {
  document.querySelector('.facets-wrapper')?.classList.remove('zz-index');
  // console.log("zz-index class removed");
});

// Also remove zz-index when the <details> is closed
document.querySelector('.disclosure-has-popup')?.addEventListener('toggle', function () {
  if (!this.open) {
    document.querySelector('.facets-wrapper')?.classList.remove('zz-index');
    // console.log("zz-index class removed via <details> toggle");
  }
});
